﻿import { StringEditor, HtmlNoteContentEditor, EnumEditor, IntegerEditor, DateTimeEditor, PrefixedContext, initFormType } from "@serenity-is/corelib";
import { EmailQueuePriority } from "./EmailQueue.EmailQueuePriority";
import { EmailQueueStatus } from "./EmailQueue.EmailQueueStatus";

export interface EmailQueueForm {
    Uid: StringEditor;
    Subject: StringEditor;
    Body: HtmlNoteContentEditor;
    MailFrom: StringEditor;
    MailTo: StringEditor;
    ReplyTo: StringEditor;
    Cc: StringEditor;
    Bcc: StringEditor;
    Priority: EnumEditor;
    Status: EnumEditor;
    RetryCount: IntegerEditor;
    LockExpiration: DateTimeEditor;
    ErrorMessage: StringEditor;
    SentDate: DateTimeEditor;
    InsertUser: StringEditor;
    InsertDate: DateTimeEditor;
}

export class EmailQueueForm extends PrefixedContext {
    static readonly formKey = 'Serenity.Pro.EmailQueue.EmailQueueForm';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!EmailQueueForm.init)  {
            EmailQueueForm.init = true;

            var w0 = StringEditor;
            var w1 = HtmlNoteContentEditor;
            var w2 = EnumEditor;
            var w3 = IntegerEditor;
            var w4 = DateTimeEditor;

            initFormType(EmailQueueForm, [
                'Uid', w0,
                'Subject', w0,
                'Body', w1,
                'MailFrom', w0,
                'MailTo', w0,
                'ReplyTo', w0,
                'Cc', w0,
                'Bcc', w0,
                'Priority', w2,
                'Status', w2,
                'RetryCount', w3,
                'LockExpiration', w4,
                'ErrorMessage', w0,
                'SentDate', w4,
                'InsertUser', w0,
                'InsertDate', w4
            ]);
        }
    }
}

[EmailQueuePriority, EmailQueueStatus]; // referenced types